<script setup lang="ts">
import FormEvento from '../components/form-evento.vue'
import { useEventoStore } from '../store/useEventoStore'

definePage({
  meta: {
    navActiveLink: 'admin-evento',
    action: 'edit',
    subject: 'evento',
  },
})

const store = useEventoStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormEvento is-editing />
</template>
